const ENTERPRISE = 'enterprise';
const PRO = 'pro';
const STANDARD = 'standard';
const BASIC = 'basic';
const FREE = 'free';
const TRIAL = 'trial';

const ORGANIZED_TIERS = [FREE, BASIC, STANDARD, PRO, ENTERPRISE, TRIAL];

export const Tiers = { ORGANIZED_TIERS, ALL_TIERS: { ENTERPRISE, PRO, STANDARD, BASIC, FREE, TRIAL } };
